
















































































































































































































































import Vue from "vue";
import Component from "vue-class-component";
import { RoleStore, UserStore, LoadingSpinnerService } from "@/store";
import { ContactProfileDto } from "@/api/ClientPortalApiClient";
import { RegisterUserCommand } from "@/api/AuthenticationApiClient";
import ApiFactory from "@/api/ApiFactory";
import { Prop } from "vue-property-decorator";

@Component
export default class ProfileWidget extends Vue {
  @Prop() contactId: number | undefined;

  private profile: ContactProfileDto | null = new ContactProfileDto();
  private clientSelectorID: number = 1;
  private isSendingInvitation: boolean = false;

  private async created() {
    await this.loadContactProfile();
    this.clientSelectorID = UserStore.clientSelectorId;
  }

  private async loadContactProfile() {
    LoadingSpinnerService.Show("Loading your profile...");
    const apiClient = ApiFactory.CreateDataClient();

    try {
      this.profile = await apiClient.profile_getByContactId(
        this.contactId || UserStore.profileId
      );
      LoadingSpinnerService.Hide();
    } catch (e) {
      LoadingSpinnerService.Failure("Unable to load your profile");
    }
  }

  get ownerEmail(): string {
    return this.profile ? this.profile.ownerEmail || "" : "";
  }
  get brokerCompanyEmailAddress(): string {
    return this.profile ? this.profile.brokerCompanyEmailAddress || "" : "";
  }
  get isAdvisor(): boolean {
    return RoleStore.isAnAdvisor;
  }

  get IsExternalBroker(): boolean {
    return RoleStore.isExternalBroker;
  }

  get IsBrokerClient(): boolean {
    return RoleStore.isBrokerClient;
  }
  private async sendPortalInvitation() {
    if (!this.profile) return;

    this.isSendingInvitation = true;
    LoadingSpinnerService.Show("Sending portal invitation...");

    try {
      const authClient = ApiFactory.CreateAuthClient();
      const cmd = new RegisterUserCommand();
      cmd.firstName = this.profile.firstName;
      cmd.lastName = this.profile.lastName;
      cmd.username = this.profile.email;
      cmd.profileId = this.profile.id;

      await authClient.users_RegisterBrokerClient(cmd);
      LoadingSpinnerService.Success("Portal invitation sent successfully.");
    } catch (e) {
      LoadingSpinnerService.Failure(
        "Failed to send portal invitation. Please try again."
      );
    } finally {
      this.isSendingInvitation = false;
    }
  }
}
